import {atob} from "./base64"

export interface JWT {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any
    exp?: number
}

export const decode = (jwt: string): JWT | undefined =>
    jwt && JSON.parse(atob(jwt.split(".")[1]))

export const tokenExpired = (jwt: string) => {
    const payload = decode(jwt)
    return payload && payload.exp && payload.exp * 1000.0 <= Date.now()
}
